import { ValidationProvider, ValidationService } from "aspnet-client-validation";

//NOTE: This must match up with the server-side implementation!

/** The 'must be true' provider name */
export const PROVIDER_NAME: string = "mustbetrue";

/**
 * Adds the 'must be true' provider to the validation service
 * @param validation The validation service
 */
export function addMustBeTrueProvider(validation: ValidationService)
{
    validation.addProvider(PROVIDER_NAME, provider);
}

/**
 * A validation provider that validates that a boolean must be true
 */
export const provider: ValidationProvider = (value, element, params) =>
{
    if (value == null)
        return true; //Let [Required] handle empty input first

    //Checking that `value === "true"` doesn't work here. We need to verify that the input is actually checked.
    return element instanceof HTMLInputElement && element.checked;
};
